import { handleSessionError } from "../../services/handleSessionError";
import { organizacjeService } from "../../services/organizacje.service";
import {
  Organizacja,
  OrganizacjaWidok,
  organizacjeConsts,
  Produkt,
  OdczytZaproszenia,
  Zaproszenie,
} from "../types/organizacje";

export const organizacjeActions = {
  dodaj,
  przegladaj,
  daj,
  edytuj,
  usun,
  dajZaproszenie,
  odrzucZaproszenie,
  akceptujZaproszenie,
  zmienWybrana,
};

function dodaj(nazwa: string, produkty: Produkt[]) {
  return (dispatch: Function) => {
    dispatch(request());
    return organizacjeService.dodaj(nazwa, produkty).then(
      () => {
        dispatch(success());
        return true;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: organizacjeConsts.DODAJ_ORGANIZACJE_REQUEST };
  }
  function success() {
    return { type: organizacjeConsts.DODAJ_ORGANIZACJE_SUCCESS };
  }
  function setError(error: string) {
    return { type: organizacjeConsts.DODAJ_ORGANIZACJE_FAILURE, error: error };
  }
}

function przegladaj() {
  return (dispatch: Function) => {
    dispatch(request());

    return organizacjeService.przegladaj().then(
      (res: OrganizacjaWidok[]) => {
        dispatch(success(res));
        return res;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: organizacjeConsts.PRZEGLADAJ_ORGANIZACJE_REQUEST };
  }
  function success(lista: OrganizacjaWidok[]) {
    return { type: organizacjeConsts.PRZEGLADAJ_ORGANIZACJE_SUCCESS, lista };
  }
  function setError(error: string) {
    return {
      type: organizacjeConsts.PRZEGLADAJ_ORGANIZACJE_FAILURE,
      error: error,
    };
  }
}

function daj(id: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return organizacjeService.daj(id).then(
      (dto: Organizacja) => {
        dispatch(success());
        return dto;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: organizacjeConsts.DAJ_ORGANIZACJE_REQUEST };
  }
  function success() {
    return { type: organizacjeConsts.DAJ_ORGANIZACJE_SUCCESS };
  }
  function setError(error: string) {
    return { type: organizacjeConsts.DAJ_ORGANIZACJE_FAILURE, error: error };
  }
}

function edytuj(id: string, nazwa: string, produkty: Produkt[]) {
  return (dispatch: Function) => {
    dispatch(request());
    return organizacjeService.edytuj(id, nazwa, produkty).then(
      () => {
        dispatch(success());
        return true;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: organizacjeConsts.EDYTUJ_ORGANIZACJE_REQUEST };
  }
  function success() {
    return { type: organizacjeConsts.EDYTUJ_ORGANIZACJE_SUCCESS };
  }
  function setError(error: string) {
    return { type: organizacjeConsts.EDYTUJ_ORGANIZACJE_FAILURE, error: error };
  }
}

function usun(id: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return organizacjeService.usun(id).then(
      () => {
        dispatch(success());
        return true;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: organizacjeConsts.USUN_ORGANIZACJE_REQUEST };
  }
  function success() {
    return { type: organizacjeConsts.USUN_ORGANIZACJE_SUCCESS };
  }
  function setError(error: string) {
    return { type: organizacjeConsts.USUN_ORGANIZACJE_FAILURE, error: error };
  }
}

function dajZaproszenie(idOrg: string, idZapr: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return organizacjeService.dajZaproszenie(idOrg, idZapr).then(
      (dto: OdczytZaproszenia) => {
        dispatch(success());
        return dto;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: organizacjeConsts.DAJ_ZAPROSZENIE_REQUEST };
  }
  function success() {
    return { type: organizacjeConsts.DAJ_ZAPROSZENIE_SUCCESS };
  }
  function setError(error: string) {
    return { type: organizacjeConsts.DAJ_ZAPROSZENIE_FAILURE, error: error };
  }
}

function odrzucZaproszenie(idOrg: string, idZapr: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return organizacjeService.odrzucZaproszenie(idOrg, idZapr).then(
      () => {
        dispatch(success());
        return true;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: organizacjeConsts.ODRZUC_ZAPROSZENIE_REQUEST };
  }
  function success() {
    return { type: organizacjeConsts.ODRZUC_ZAPROSZENIE_SUCCESS };
  }
  function setError(error: string) {
    return { type: organizacjeConsts.ODRZUC_ZAPROSZENIE_FAILURE, error: error };
  }
}

function akceptujZaproszenie(idOrg: string, idZapr: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return organizacjeService.potwierdzZaproszenie(idOrg, idZapr).then(
      (result: Zaproszenie) => {
        dispatch(success());
        return result;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: organizacjeConsts.POTWIERDZ_ZAPROSZENIE_REQUEST };
  }
  function success() {
    return { type: organizacjeConsts.POTWIERDZ_ZAPROSZENIE_SUCCESS };
  }
  function setError(error: string) {
    return {
      type: organizacjeConsts.POTWIERDZ_ZAPROSZENIE_FAILURE,
      error: error,
    };
  }
}

function zmienWybrana(org: OrganizacjaWidok) {
  return {
    type: organizacjeConsts.ZMIEN_WYBRANA_ORGANIZACJE,
    wybrana: org,
  };
}
